var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 212.324,
    height: 82.385,
    viewBox: "0 0 212.324 82.385",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2be690"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00502b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1336",
    "data-name": "Group 1336",
    transform: "translate(-158.458 -259.167)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1336-2",
    "data-name": "Group 1336",
    transform: "translate(158.458 264.621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2489",
    "data-name": "Path 2489",
    d: "M194.868,270.679a21.9,21.9,0,0,0-18.94,10.887,14.37,14.37,0,1,1,12.043,22.2h-5.664v-8.709L175.17,302.2,173.6,303.77c.015-.016.024-.013.029,0H173.6l-15.112,15.112h29.48A29.559,29.559,0,0,0,215.635,299.6a21.928,21.928,0,0,0-20.767-28.921Z",
    transform: "translate(-158.464 -259.913)",
    fill: "#2be690"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2490",
    "data-name": "Path 2490",
    d: "M217.455,287.248a29.485,29.485,0,1,0-58.97,0v29.485h.005L173.6,301.62V287.248a14.331,14.331,0,0,1,2.33-7.832,21.918,21.918,0,0,1,39.707,18.034A29.343,29.343,0,0,0,217.455,287.248Z",
    transform: "translate(-158.463 -257.763)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1155",
    "data-name": "Rectangle 1155",
    width: 15.141,
    height: 15.141,
    transform: "translate(0 61.79)",
    fill: "#2be690"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2491",
    "data-name": "Path 2491",
    d: "M323.4,277.814l4.242,4.242-2.086,2.086a15.091,15.091,0,0,1-21.411,0,14.328,14.328,0,0,1-3.3-5.015,15.691,15.691,0,0,1-1.078-5.69,15.427,15.427,0,0,1,1.078-5.655,14.41,14.41,0,0,1,3.3-4.983,14.752,14.752,0,0,1,5.016-3.333,15.133,15.133,0,0,1,11.379,0,14.784,14.784,0,0,1,5.016,3.333l2.086,2.087-16.764,16.765a8.968,8.968,0,0,0,10.436-1.75Zm-15.014-10.84a9.007,9.007,0,0,0-1.75,10.436l2.457-2.458q1.649-1.648,3.5-3.5t3.569-3.535q1.717-1.682,2.66-2.626a9.031,9.031,0,0,0-5.42-.876A8.657,8.657,0,0,0,308.383,266.975Z",
    transform: "translate(-39.754 11.9)",
    fill: "#2be690"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1337",
    "data-name": "Group 1337",
    transform: "translate(313.706 269.599)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2492",
    "data-name": "Path 2492",
    d: "M378.582,257.568a12.14,12.14,0,0,0-12.173,12.078v18.817h6.555V269.646a5.6,5.6,0,0,1,5.618-5.575h1.489v-6.5Z",
    transform: "translate(-366.409 -257.568)",
    fill: "#2be690"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1338",
    "data-name": "Group 1338",
    transform: "translate(332.619 310.656)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2493",
    "data-name": "Path 2493",
    d: "M402.116,313.161a12.14,12.14,0,0,0-12.174,12.078v18.817H396.5V325.239a5.6,5.6,0,0,1,5.618-5.575h1.49v-6.5Z",
    transform: "translate(-389.943 -313.161)",
    fill: "#2be690"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2494",
    "data-name": "Path 2494",
    d: "M378.324,343.924H362.543a15.78,15.78,0,1,1,15.781-15.779Zm-15.781-25a9.225,9.225,0,1,0,0,18.45h9.225v-9.225A9.236,9.236,0,0,0,362.543,318.92Z",
    transform: "translate(-49.244 -2.372)",
    fill: "#2be690"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2495",
    "data-name": "Path 2495",
    d: "M400.056,288.861a15.781,15.781,0,1,1,15.78-15.78A15.8,15.8,0,0,1,400.056,288.861Zm0-25.005a9.225,9.225,0,1,0,9.225,9.225A9.236,9.236,0,0,0,400.056,263.856Z",
    transform: "translate(-57.291 12.076)",
    fill: "#2be690"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2496",
    "data-name": "Path 2496",
    d: "M353.372,280.09a7.068,7.068,0,0,1-7.06-7.06v-10.38h10.6V256.1h-10.6V245.052l-6.556,6.555v4.5l-6.54,6.54h6.54v10.38a13.631,13.631,0,0,0,13.616,13.615h4.063V280.09Z",
    transform: "translate(-46.371 14.115)",
    fill: "#2be690"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2497",
    "data-name": "Path 2497",
    d: "M427.842,335.046a7.131,7.131,0,0,1-7.122-7.122V317.452h10.693v-6.613H420.719V299.7l-6.613,6.613v4.543l-6.6,6.6h6.6v10.471a13.751,13.751,0,0,0,13.736,13.736h4.1v-6.613Z",
    transform: "translate(-61.159 -0.263)",
    fill: "#2be690"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2498",
    "data-name": "Path 2498",
    d: "M355.714,285.5",
    transform: "translate(-50.339 5.35)",
    fill: "#2be690"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2499",
    "data-name": "Path 2499",
    d: "M276.374,258.356a15.2,15.2,0,0,0-8.875,2.851v-2.851h-6.42v46.49l6.42-6.527V286.1a15.291,15.291,0,1,0,8.875-27.741Zm0,24.1a8.8,8.8,0,1,1,8.8-8.8A8.813,8.813,0,0,1,276.374,282.455Z",
    transform: "translate(-32.019 11.9)",
    fill: "#2be690"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2500",
    "data-name": "Path 2500",
    d: "M323.49,313.707a11.2,11.2,0,0,0-7.948,3.3,11.225,11.225,0,0,0-19.18,7.927v19.209h6.556V324.939a4.674,4.674,0,0,1,9.347-.117c0,.039-.006.078-.006.117v19.209h6.567V324.939c0-.039-.006-.078-.006-.117a4.674,4.674,0,0,1,9.347.117v19.209h6.555V324.939A11.245,11.245,0,0,0,323.49,313.707Z",
    transform: "translate(-39.188 -2.596)",
    fill: "#2be690"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1339",
    "data-name": "Group 1339",
    transform: "translate(229.611 310.208)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2501",
    "data-name": "Path 2501",
    d: "M286.207,330.878a9.1,9.1,0,0,0-2.024-2.966,9.837,9.837,0,0,0-3-1.99,9.209,9.209,0,0,0-3.665-.733h-6.422a2.974,2.974,0,0,1-2.233-.943,3.149,3.149,0,0,1-.908-2.268,3.1,3.1,0,0,1,3.141-3.142h9.54l6.213-6.212H271.094a9.2,9.2,0,0,0-3.664.733,9.228,9.228,0,0,0-4.956,4.956,9.523,9.523,0,0,0,0,7.33,9.78,9.78,0,0,0,1.989,3,9.085,9.085,0,0,0,2.967,2.025,9.2,9.2,0,0,0,3.664.733h6.422a3.128,3.128,0,0,1,2.3.907,3.041,3.041,0,0,1,.907,2.235,3.1,3.1,0,0,1-3.211,3.211h-8.658l-6.076,6.076.132.137h14.6a9.21,9.21,0,0,0,3.665-.733,9.478,9.478,0,0,0,5.026-5.027,9.533,9.533,0,0,0,0-7.33Z",
    transform: "translate(-261.74 -312.624)",
    fill: "#2be690"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5a12945f012c85293cc61bd46cdefc3a.svg";
export { ForwardRef as ReactComponent };